import { render, staticRenderFns } from "./NgoSearch.vue?vue&type=template&id=375b5bc3&"
import script from "./NgoSearch.vue?vue&type=script&lang=js&"
export * from "./NgoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports